import React, { useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { E_ACCOUNT_DEACTIVATED, E_MULTIPLE_LOGIN_DETECTED, E_MULTIPLE_LOGIN_DETECTED_SUB } from "../../../utils/constants";
import { resetTokenExpiredHandling } from "../../../api/api";

interface TokenErrorModalProps {
    type: "expired" | "deactivated";
    open: boolean;
}

const style = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "#121212",
    color: "#fff",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    minWidth: 300,
    textAlign: "center"
};

export const TokenErrorModal: React.FC<TokenErrorModalProps> = ({ type, open }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                resetTokenExpiredHandling();
                // navigate("/login");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [open, navigate]);

    return (
        <Modal
            open={open}
            onClose={(_, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
            }}
            disableEscapeKeyDown
        >
            <Box sx={style}>
                <Typography>
                    <Box component="span" sx={{ color: 'red', fontWeight: 'bold' }}>
                        Warning!
                    </Box>{' '}
                    {type === "expired" ? E_MULTIPLE_LOGIN_DETECTED : E_ACCOUNT_DEACTIVATED}
                </Typography>
                <Typography sx={{ mt: 2 }}>
                    {E_MULTIPLE_LOGIN_DETECTED_SUB}
                </Typography>
            </Box>
        </Modal>
    );
};